import React from "react";
import NewCourseHeroImage from "../Assets/NewCourseHeroImage.png";

const RegisterNewCourseHeroSection = () => {
  return (
    <div className="w-full h-[280px] lg:h-[310px] bg-cover bg-center relative flex justify-center items-center rounded-b-[30px] lg:rounded-b-none">
      <img
        src={NewCourseHeroImage}
        alt="Learner preparing for Ontario G2 or G road test with Vehicle Learning Innovation"
        className="absolute top-0 left-0 w-full h-full object-cover rounded-b-[30px] lg:rounded-b-none"
      />

      <div className="relative w-[92%] lg:w-[80%] mt-[50px] lg:mt-[0px]">
        <h1 className="m-0 text-[26px] lg:text-[45px] font-bold text-[#fff] lg:text-center leading-tight">
          <span className="block">Ready to Pass Your G2 or G Test?</span>
          <span className="block">
            Practice Makes Perfect — When It’s the Right Practice
          </span>
        </h1>
      </div>
    </div>
  );
};

export default RegisterNewCourseHeroSection;
